import { numericFormatter } from "react-number-format";

export type FormatNumberFunction = (
  inputNumber: number,
  options?: {
    digits?: number;
    round?: boolean;
    negativeAllowed?: boolean;
    displayStringForInvalidValues?: string;
    thousandSeparator?: string;
    decimalSeparator?: string;
  },
) => string;

export const formatNumber: FormatNumberFunction = (inputNumber, options = {}): string => {
  const {
    digits = 0,
    negativeAllowed = true,
    displayStringForInvalidValues = "-",
    thousandSeparator = ".",
    decimalSeparator = ",",
  } = options;

  if (isNaN(inputNumber) || (!negativeAllowed && inputNumber < 0)) {
    return displayStringForInvalidValues;
  }

  const inputNumberAsString = inputNumber % 1 > 0 ? inputNumber.toFixed(digits) : inputNumber.toString();

  return numericFormatter(inputNumberAsString, {
    thousandSeparator,
    decimalSeparator,
    decimalScale: digits,
  });
};
